import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestPostageMetersWrapper from "@components/layouts/bestpostagemetersWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function BestPostageMetersHome(): ReactElement {
    return (
        <BestPostageMetersWrapper>
            <PrivacyPolicy
                category="Postage Meters"
                domain="BestPostageMeters.com"
            />
        </BestPostageMetersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
